/**
 * @generated SignedSource<<ccac6c74427ad4697060219271108048>>
 * @relayHash 8b10fb406968f0e5e3cf35ec36a05aa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb46bd4451d8f1d15edcfa586f70587e7d48486499c7b848e4e94a1b54e7dc72

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiCsmWidgetConfigurationQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type uiCsmWidgetConfigurationQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type uiCsmWidgetConfigurationQuery = {
  response: uiCsmWidgetConfigurationQuery$data;
  variables: uiCsmWidgetConfigurationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiCsmWidgetConfigurationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                  }
                ],
                "type": "HelpCenter"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiCsmWidgetConfigurationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "allowedDomains"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isAnonymousAccessEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "concreteType": "CsmAiWidgetBrandingTheme",
                        "kind": "LinkedField",
                        "name": "theme",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "colorVibeVariant"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "radius"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "space"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "chatColor"
                          },
                          {
                            "concreteType": "CsmAiWidgetBrandingAttribution",
                            "kind": "LinkedField",
                            "name": "attribution",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "text"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ]
              },
              (v4/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fb46bd4451d8f1d15edcfa586f70587e7d48486499c7b848e4e94a1b54e7dc72",
    "metadata": {},
    "name": "uiCsmWidgetConfigurationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fdf048ba866840ae55a5f245f06e26dc";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
